<script>
  import { formatDate } from '../utils'
  export let textColor
  export let date
  export let dateFormat
</script>

<span style="color: {textColor};">{formatDate(date, dateFormat)}</span>
